import { render, staticRenderFns } from "./ZL.vue?vue&type=template&id=072bc246&scoped=true&"
import script from "./ZL.vue?vue&type=script&lang=js&"
export * from "./ZL.vue?vue&type=script&lang=js&"
import style0 from "./ZL.vue?vue&type=style&index=0&id=072bc246&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072bc246",
  null
  
)

export default component.exports